const routes = [
  {
    path: '/ultimate/analysis/insurancecompanies',
    component: () => import('@/views/ultimate/analysis/insuranceCompanies'),
    name: 'insurance-companies',
    meta: {
      title: '保险公司分析'
    }
  },
  {
    path: '/ultimate/analysis/regionalproportion',
    component: () => import('@/views/ultimate/analysis/regionalProportion'),
    name: 'regional-proportion',
    meta: {
      title: '区域占比分析'
    }
  },
  {
    path: '/ultimate/analysis/carmodelproportion',
    component: () => import('@/views/ultimate/analysis/carModelProportion'),
    name: 'car-model-proportion',
    meta: {
      title: '车型占比分析'
    }
  },
  {
    path: '/ultimate/analysis/insuranceproportion',
    component: () => import('@/views/ultimate/analysis/insuranceProportion'),
    name: 'insurance-proportion',
    meta: {
      title: '险种占比分析'
    }
  },
  {
    path: '/ultimate/analysis/insurancetypestat',
    component: () => import('@/views/ultimate/analysis/insuranceTypeStat'),
    name: 'insurance-type-stat',
    meta: {
      title: '交商占比分析'
    }
  },
  {
    path: '/ultimate/analysis/newoldcarproportion',
    component: () => import('@/views/ultimate/analysis/newOldCarProportion'),
    name: 'new-old-car-proportion',
    meta: {
      title: '新旧车占比分析'
    }
  },
  {
    path: '/ultimate/analysis/salesmananalysis',
    component: () => import('@/views/ultimate/analysis/salesmanAnalysis'),
    name: 'salesman-analysis',
    meta: {
      title: '业务员统计分析'
    }
  },
  {
    path: '/ultimate/analysis/branchorganalysis',
    component: () => import('@/views/ultimate/analysis/branchOrgAnalysis'),
    name: 'branch-org-analysis',
    meta: {
      title: '组织部门业绩分析'
    }
  },
  {
    path: '/ultimate/analysis/branchanalysis',
    component: () => import('@/views/ultimate/analysis/branchAnalysis'),
    name: 'branch-analysis',
    meta: {
      title: '分支机构分析'
    }
  },
  {
    path: '/ultimate/analysis/branchtypeanalysis',
    component: () => import('@/views/ultimate/analysis/branchTypeAnalysis'),
    name: 'branch-type-analysis',
    meta: {
      title: '业务来源分析'
    }
  },
  {
    path: '/ultimate/analysis/jobnoanalysis',
    component: () => import('@/views/ultimate/analysis/jobNoAnalysis'),
    name: 'job-no-analysis',
    meta: {
      title: '工号数据分析'
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/ultimate/analysis.js